<div class="p-grid">
  <div class="p-col-12 mt-2">
    <i-title text="Actions" class="box" level="1"> </i-title>
  </div>
</div>
@if (isLoaded) {
  <section>
    <div class="p-grid">
      <div class="p-col-12 mt-3 mb-3">
        <i-tabs-xl-v2
          [tabs]="actionTabs"
          [currentTabId]="actionTabsActive"
          (onSelectTab)="receiveActionTabs($event)"
          (currentTabIdChange)="changeCurrentTabId($event)"></i-tabs-xl-v2>
      </div>
      <div class="p-col-12">
        @switch (actionTabsActive) {
          <!-- ? Actions : toutes -->
          @case ('all') {
            <div class="p-grid">
              <!-- Search et changement de vue -->
              <div class="d-flex w-100 align-items-center justify-content-between">
                <span class="p-input-icon-left w-25" [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field w-100 pe-5 ps-5 w-100 advSearch__field"
                    [placeholder]="'action.searchInDisplayedActions' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchAction()" />
                </span>
                <p-dropdown
                  [ngClass]="{ contentHidden: !this.actionSearchDropdown }"
                  optionLabel="description"
                  optionValue="description"
                  [placeholder]="'action.filterByAction' | translate"
                  showClear="true"
                  [(ngModel)]="actionSearchDropdown"
                  [options]="actionTypes"
                  (onChange)="paginate('all', actionsListAll.pageNumber)">
                </p-dropdown>
                <p-selectButton
                  [allowEmpty]="false"
                  class="selectButton_recipient_tab"
                  [options]="justifyOptions"
                  [(ngModel)]="valueJustifyOption"
                  optionLabel="icon"
                  (onChange)="getSelectButtonValue('all')">
                  <ng-template let-item pTemplate>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectButton>
              </div>
              <!-- no result -->
              @if (actionsListAll?.items?.length === 0) {
                <div class="p-col-12 h-100">
                  <div class="box d-flex align-items-center justify-content-center py-4 text-center">
                    <h2 class="custom-h4-title py-4">
                      {{ 'action.congratulationsNoActions' | translate }} <br />
                      {{ 'action.youDeserveCoffee' | translate }}
                    </h2>
                  </div>
                  <div class="box d-flex align-items-center justify-content-center py-4">
                    <img src="./assets/img/undraw_coffee_break_j3of.svg" width="35%" [alt]="'action.noActions' | translate" class="img-fluid" />
                  </div>
                </div>
              }
              @if (actionsListAll?.items?.length !== 0) {
                <div class="listActions p-col-12 mt-3">
                  <!-- Vue liste -->
                  @if (valueJustifyOption?.state === 'list') {
                    <section class="overflowAuto">
                      @for (
                        action of actionsListAll?.items | filterByPropertyNotNull: 'action' | advancedSearch: dataSearch : excludedKeys;
                        track action
                      ) {
                        <app-action-card [action]="action" [mode]="actionTabsActive" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
                      }
                    </section>
                  }
                  @if (valueJustifyOption?.state === 'list') {
                    <div class="d-flex justify-content-center align-items-center">
                      <p-paginator
                        #pgAll
                        [first]="firstAll"
                        [rows]="actionsListAll?.pageSize"
                        [rowsPerPageOptions]="[100, 200, 500, 1000, 5000]"
                        [totalRecords]="actionsListAll?.totalCount"
                        (onPageChange)="onPageChange($event, 'all')"
                        [templateRight]="divRightAll"
                        [showJumpToPageDropdown]="false">
                        <ng-template #divRightAll>
                          <span class="darkBlueColor">{{ 'action.itemsPerPage' | translate }}</span>
                        </ng-template>
                      </p-paginator>
                    </div>
                  }
                  <!-- Vue tableau -->
                  @if (valueJustifyOption.state === 'table') {
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <p-dropdown [(ngModel)]="sizeChoice" [options]="sizeOfPages" (onChange)="changePageSize($event, 'all')"> </p-dropdown>
                      </div>
                      <div>
                        <small class="me-3">{{
                          'pageOn' | translate: { pageNumber: actionsListAll?.pageNumber, pageSize: actionsListAll?.totalPages }
                        }}</small>
                        <div>
                          @if (+actionsListAll?.pageNumber !== 1) {
                            <button
                              class="super-compos-secondary-btn me-1"
                              (click)="paginate('all', +actionsListAll?.pageNumber - 1)"
                              style="border-radius: 6px 0px 0px 6px">
                              <img src="./assets/img/arrow_l.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                          @if (actionsListAll?.pageNumber !== actionsListAll?.totalPages && actionsListAll?.totalPages > 1) {
                            <button
                              [disabled]="actionsListAll?.pageNumber === actionsListAll?.totalPages"
                              class="super-compos-secondary-btn"
                              (click)="paginate('all', +actionsListAll?.pageNumber + 1)"
                              style="border-radius: 0px 6px 6px 0px">
                              <img src="./assets/img/arrow_r.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (valueJustifyOption.state === 'table') {
                    <div>
                      @if (superTableLoaded) {
                        <i-table
                          id="actionSuperTablesAllsViewTable"
                          class="super-table"
                          [columns]="columns"
                          [paginator]="true"
                          [rows]="actionsListAll?.pageSize"
                          [totalRecords]="actionsListAll?.totalCount"
                          [firstPage]="0"
                          [items]="actionsListAll?.items"
                          [multiselect]="false">
                        </i-table>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- ? Actions : A faire -->
          @case ('week') {
            <div class="p-grid">
              <!-- Search et changement de vue -->
              <div class="d-flex w-100 align-items-center justify-content-between">
                <span class="p-input-icon-left w-25" [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field pe-5 ps-5 w-100 advSearch__field"
                    [placeholder]="'action.searchInDisplayedActions' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchAction()" />
                </span>
                <p-dropdown
                  [ngClass]="{ contentHidden: !this.actionSearchDropdown }"
                  optionLabel="description"
                  optionValue="description"
                  [placeholder]="'action.filterByAction' | translate"
                  showClear="true"
                  [(ngModel)]="actionSearchDropdown"
                  [options]="actionTypes"
                  (onChange)="paginate('week', actionsListWeek.pageNumber)">
                </p-dropdown>
                <p-selectButton
                  [allowEmpty]="false"
                  class="selectButton_recipient_tab"
                  [options]="justifyOptions"
                  [(ngModel)]="valueJustifyOption"
                  optionLabel="icon"
                  (onChange)="getSelectButtonValue('week')">
                  <ng-template let-item pTemplate>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectButton>
              </div>
              <!-- no result -->
              @if (actionsListWeek?.items?.length === 0) {
                <div class="p-col-12 h-100">
                  <div class="box d-flex align-items-center justify-content-center py-4 text-center">
                    <h2 class="custom-h4-title py-4">
                      {{ 'action.congratulationsNoActions' | translate }} <br />
                      {{ 'action.youDeserveCoffee' | translate }}
                    </h2>
                  </div>
                  <div class="box d-flex align-items-center justify-content-center py-4">
                    <img src="./assets/img/undraw_coffee_break_j3of.svg" width="35%" [alt]="'noActionCat' | translate" class="img-fluid" />
                  </div>
                </div>
              }
              @if (actionsListWeek?.items?.length !== 0) {
                <div class="listActions p-col-12 mt-3">
                  <!-- Vue liste -->
                  @if (valueJustifyOption?.state === 'list') {
                    <section class="overflowAuto">
                      @for (
                        action of actionsListWeek?.items | filterByPropertyNotNull: 'action' | advancedSearch: dataSearch : excludedKeys;
                        track action
                      ) {
                        <app-action-card [action]="action" [mode]="actionTabsActive" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
                      }
                    </section>
                  }
                  @if (valueJustifyOption?.state === 'list') {
                    <div class="d-flex justify-content-center align-items-center">
                      <p-paginator
                        #pgWeek
                        [first]="firstWeek"
                        [rows]="actionsListWeek?.pageSize"
                        [rowsPerPageOptions]="[100, 200, 500, 1000, 5000]"
                        [totalRecords]="actionsListWeek?.totalCount"
                        (onPageChange)="onPageChange($event, 'week')"
                        [templateRight]="divRightWeek"
                        [showJumpToPageDropdown]="false">
                        <ng-template #divRightWeek>
                          <span class="darkBlueColor">{{ 'action.itemsPerPage' | translate }}</span>
                        </ng-template>
                      </p-paginator>
                    </div>
                  }
                  <!-- Vue tableau -->
                  @if (valueJustifyOption.state === 'table') {
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <p-dropdown
                          [(ngModel)]="sizeChoice"
                          [options]="sizeOfPages"
                          (onChange)="changePageSize($event, 'week')"
                          inputStyleClass="w-100"
                          styleClass="dropdown-inforius">
                        </p-dropdown>
                      </div>
                      <div>
                        <small class="me-3">{{
                          'pageOn' | translate: { pageNumber: actionsListWeek?.pageNumber, pageSize: actionsListWeek?.totalPages }
                        }}</small>
                        <div>
                          @if (+actionsListWeek?.pageNumber !== 1) {
                            <button
                              class="super-compos-secondary-btn me-1"
                              (click)="paginate('week', +actionsListWeek?.pageNumber - 1)"
                              style="border-radius: 6px 0px 0px 6px">
                              <img src="./assets/img/arrow_l.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                          @if (actionsListWeek?.pageNumber !== actionsListWeek?.totalPages && actionsListWeek?.totalPages > 1) {
                            <button
                              [disabled]="actionsListWeek?.pageNumber === actionsListWeek?.totalPages"
                              class="super-compos-secondary-btn"
                              (click)="paginate('week', +actionsListWeek?.pageNumber + 1)"
                              style="border-radius: 0px 6px 6px 0px">
                              <img src="./assets/img/arrow_r.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (valueJustifyOption.state === 'table') {
                    <div>
                      @if (superTableLoaded) {
                        <i-table
                          id="actionsSuperTableWeek1"
                          class="super-table box"
                          [columns]="columns"
                          [items]="actionsListWeek?.items"
                          [multiselect]="false"
                          [paginator]="true"
                          [rows]="actionsListWeek?.pageSize"
                          [totalRecords]="actionsListWeek?.totalCount"
                          [firstPage]="0">
                        </i-table>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- ? Actions : Terminées -->
          @case ('finished') {
            <div class="p-grid">
              <!-- Search et changement de vue -->
              <div class="d-flex w-100 align-items-center justify-content-between">
                <span class="p-input-icon-left w-25" [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field pe-5 ps-5 w-100 advSearch__field"
                    [placeholder]="'action.searchInDisplayedActions' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchAction()" />
                </span>
                <p-dropdown
                  [ngClass]="{ contentHidden: !this.actionSearchDropdown }"
                  optionLabel="description"
                  optionValue="description"
                  [placeholder]="'action.filterByAction' | translate"
                  showClear="true"
                  [(ngModel)]="actionSearchDropdown"
                  [options]="actionTypes"
                  (onChange)="paginate('finished', actionsListFinish.pageNumber)">
                </p-dropdown>
                <p-selectButton
                  [allowEmpty]="false"
                  class="selectButton_recipient_tab"
                  [options]="justifyOptions"
                  [(ngModel)]="valueJustifyOption"
                  optionLabel="icon"
                  (onChange)="getSelectButtonValue('finished')">
                  <ng-template let-item pTemplate>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectButton>
              </div>
              <!-- no result -->
              @if (actionsListFinish?.items?.length === 0) {
                <div class="p-col-12 h-100">
                  <div class="box d-flex align-items-center justify-content-center py-4 text-center">
                    <h2 class="custom-h4-title py-4">
                      {{ 'action.congratulationsNoActions' | translate }} <br />
                      {{ 'action.youDeserveCoffee' | translate }}
                    </h2>
                  </div>
                  <div class="box d-flex align-items-center justify-content-center py-4">
                    <img src="./assets/img/undraw_coffee_break_j3of.svg" width="35%" [alt]="'noActionCat' | translate" class="img-fluid" />
                  </div>
                </div>
              }
              @if (actionsListFinish?.items?.length !== 0) {
                <div class="listActions p-col-12 mt-3">
                  <!-- Vue liste -->
                  @if (valueJustifyOption?.state === 'list') {
                    <section class="overflowAuto">
                      @for (
                        action of actionsListFinish?.items | filterByPropertyNotNull: 'action' | advancedSearch: dataSearch : excludedKeys;
                        track action
                      ) {
                        <app-action-card [action]="action" [mode]="actionTabsActive" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
                      }
                    </section>
                  }
                  @if (valueJustifyOption?.state === 'list') {
                    <div class="d-flex justify-content-center align-items-center">
                      <p-paginator
                        #pgFinished
                        [first]="firstFinished"
                        [rows]="actionsListFinish?.pageSize"
                        [rowsPerPageOptions]="[100, 200, 500, 1000, 5000]"
                        [totalRecords]="actionsListFinish?.totalCount"
                        (onPageChange)="onPageChange($event, 'finished')"
                        [templateRight]="divRightFinish"
                        [showJumpToPageDropdown]="false">
                        <ng-template #divRightFinish>
                          <span class="darkBlueColor">{{ 'action.itemsPerPage' | translate }}</span>
                        </ng-template>
                      </p-paginator>
                    </div>
                  }
                  <!-- Vue tableau -->
                  @if (valueJustifyOption.state === 'table') {
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <p-dropdown
                          [(ngModel)]="sizeChoice"
                          [options]="sizeOfPages"
                          (onChange)="changePageSize($event, 'finished')"
                          inputStyleClass="w-100"
                          styleClass="dropdown-inforius">
                        </p-dropdown>
                      </div>
                      <div>
                        <small class="me-3">{{
                          'pageOn' | translate: { pageNumber: actionsListFinish?.pageNumber, pageSize: actionsListFinish?.totalPages }
                        }}</small>
                        <div>
                          @if (+actionsListFinish?.pageNumber !== 1) {
                            <button
                              class="super-compos-secondary-btn me-1"
                              (click)="paginate('finished', +actionsListFinish?.pageNumber - 1)"
                              style="border-radius: 6px 0px 0px 6px">
                              <img src="./assets/img/arrow_l.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                          @if (actionsListFinish?.pageNumber !== actionsListFinish?.totalPages && actionsListFinish?.totalPages > 1) {
                            <button
                              [disabled]="actionsListFinish?.pageNumber === actionsListFinish?.totalPages"
                              class="super-compos-secondary-btn"
                              (click)="paginate('finished', +actionsListFinish?.pageNumber + 1)"
                              style="border-radius: 0px 6px 6px 0px">
                              <img src="./assets/img/arrow_r.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (valueJustifyOption.state === 'table') {
                    <div>
                      @if (superTableLoaded) {
                        <i-table
                          id="actionsSuperTableFinish1"
                          class="super-table box"
                          [columns]="columns"
                          [items]="actionsListFinish?.items"
                          [multiselect]="false"
                          [paginator]="true"
                          [rows]="actionsListFinish?.pageSize"
                          [totalRecords]="actionsListFinish?.totalCount"
                          [firstPage]="0"></i-table>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- ? Actions : Demandées par moi -->
          @case ('asked') {
            <div class="p-grid">
              <!-- Search et changement de vue -->
              <div class="d-flex w-100 align-items-center justify-content-between">
                <span class="p-input-icon-left w-25" [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field pe-5 ps-5 w-100 advSearch__field"
                    [placeholder]="'action.searchInDisplayedActions' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchAction()" />
                </span>
                <i-tabs
                  [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }"
                  class="box"
                  [items]="typeOfActionsOptions"
                  (tabChange)="changeSubTab($event)"></i-tabs>
                <p-dropdown
                  [ngClass]="{ contentHidden: !this.actionSearchDropdown }"
                  optionLabel="description"
                  optionValue="description"
                  [placeholder]="'action.filterByAction' | translate"
                  [(ngModel)]="actionSearchDropdown"
                  showClear="true"
                  [options]="actionTypes"
                  (onChange)="paginate('asked', actionsListAsked.pageNumber)">
                </p-dropdown>
                <p-selectButton
                  [allowEmpty]="false"
                  class="selectButton_recipient_tab"
                  [options]="justifyOptions"
                  [(ngModel)]="valueJustifyOption"
                  optionLabel="icon"
                  (onChange)="getSelectButtonValue('asked')">
                  <ng-template let-item pTemplate>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectButton>
              </div>
              <!-- no result -->
              @if (actionsListAsked?.items?.length === 0) {
                <div class="p-col-12 h-100">
                  <div class="box d-flex align-items-center justify-content-center py-4 text-center">
                    <h2 class="custom-h4-title py-4">
                      {{ 'action.congratulationsNoActions' | translate }} <br />
                      {{ 'action.youDeserveCoffee' | translate }}
                    </h2>
                  </div>
                  <div class="box d-flex align-items-center justify-content-center py-4">
                    <img src="./assets/img/undraw_coffee_break_j3of.svg" width="35%" [alt]="'action.noActions' | translate" class="img-fluid" />
                  </div>
                </div>
              }
              @if (actionsListAsked?.items?.length !== 0) {
                <div class="listActions p-col-12 mt-3">
                  <!-- Vue liste -->
                  @if (valueJustifyOption?.state === 'list') {
                    <section class="overflowAuto">
                      @for (
                        action of actionsListAsked?.items | filterByPropertyNotNull: 'action' | advancedSearch: dataSearch : excludedKeys;
                        track action
                      ) {
                        <app-action-card [action]="action" [mode]="actionTabsActive" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
                      }
                    </section>
                  }
                  @if (valueJustifyOption?.state === 'list') {
                    <div class="d-flex justify-content-center align-items-center">
                      <p-paginator
                        #pgAsked
                        [first]="firstAsked"
                        [rows]="actionsListAsked?.pageSize"
                        [totalRecords]="actionsListAsked?.totalCount"
                        [rowsPerPageOptions]="[100, 200, 500, 1000, 5000]"
                        (onPageChange)="onPageChange($event, 'asked')"
                        [templateRight]="divRightAsked"
                        [showJumpToPageDropdown]="false">
                        <ng-template #divRightAsked>
                          <span class="darkBlueColor">{{ 'action.itemsPerPage' | translate }}</span>
                        </ng-template>
                      </p-paginator>
                    </div>
                  }
                  <!-- Vue tableau -->
                  @if (valueJustifyOption.state === 'table') {
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <p-dropdown
                          [(ngModel)]="sizeChoice"
                          [options]="sizeOfPages"
                          (onChange)="changePageSize($event, 'asked')"
                          inputStyleClass="w-100"
                          styleClass="dropdown-inforius">
                        </p-dropdown>
                      </div>
                      <div>
                        <i-tabs class="box py-4" [items]="typeOfActionsOptions" (tabChange)="changeSubTab($event)"></i-tabs>
                      </div>
                      <div>
                        <small class="me-3">{{
                          'pageOn' | translate: { pageNumber: actionsListAsked?.pageNumber, pageSize: actionsListAsked?.totalPages }
                        }}</small>
                        <div>
                          @if (+actionsListAsked?.pageNumber !== 1) {
                            <button
                              class="super-compos-secondary-btn me-1"
                              (click)="paginate('asked', +actionsListAsked?.pageNumber - 1)"
                              style="border-radius: 6px 0px 0px 6px">
                              <img src="./assets/img/arrow_l.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                          @if (actionsListAsked?.pageNumber !== actionsListAsked?.totalPages && actionsListAsked?.totalPages > 1) {
                            <button
                              [disabled]="actionsListAsked?.pageNumber === actionsListAsked?.totalPages"
                              class="super-compos-secondary-btn"
                              (click)="paginate('asked', +actionsListAsked?.pageNumber + 1)"
                              style="border-radius: 0px 6px 6px 0px">
                              <img src="./assets/img/arrow_r.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (valueJustifyOption.state === 'table') {
                    <div>
                      @if (superTableLoaded) {
                        <i-table
                          id="actionsSuperTableAskeds1"
                          class="super-table box"
                          [columns]="columns"
                          [items]="actionsListAsked?.items"
                          [multiselect]="false"
                          [paginator]="true"
                          [rows]="actionsListAsked?.pageSize"
                          [totalRecords]="actionsListAsked?.totalCount"
                          [firstPage]="0"></i-table>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- ? Actions : Demandées aux membres de mes services -->
          @case ('assignedToMyTeam') {
            <div class="p-grid">
              <!-- Search et changement de vue -->
              <div class="d-flex w-100 align-items-center justify-content-between">
                <span class="p-input-icon-left w-25" [ngClass]="{ contentHidden: valueJustifyOption?.state !== 'list' }">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field pe-5 ps-5 w-100 advSearch__field"
                    [placeholder]="'action.searchInDisplayedActions' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchAction()" />
                </span>
                <p-dropdown
                  [placeholder]="'action.selectMember' | translate"
                  [(ngModel)]="actionMembresServiceSearchDropdown"
                  showClear="true"
                  [options]="actionMembresService"
                  (onChange)="paginate('assignedToMyTeam', actionsListAssignedToMyTeam.pageNumber)">
                </p-dropdown>
                <p-dropdown
                  [ngClass]="{ contentHidden: !this.actionSearchDropdown }"
                  optionLabel="description"
                  optionValue="description"
                  [placeholder]="'action.filterByAction' | translate"
                  [(ngModel)]="actionSearchDropdown"
                  showClear="true"
                  [options]="actionTypes"
                  (onChange)="paginate('assignedToMyTeam', actionsListAssignedToMyTeam.pageNumber)">
                </p-dropdown>
                <p-selectButton
                  [allowEmpty]="false"
                  class="selectButton_recipient_tab"
                  [options]="justifyOptions"
                  [(ngModel)]="valueJustifyOption"
                  optionLabel="icon"
                  (onChange)="getSelectButtonValue('assignedToMyTeam')">
                  <ng-template let-item pTemplate>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectButton>
              </div>
              <!-- no result -->
              @if (actionsListAssignedToMyTeam?.items?.length === 0) {
                <div class="p-col-12 h-100">
                  <div class="box d-flex align-items-center justify-content-center py-4 text-center">
                    <h2 class="custom-h4-title py-4">
                      {{ 'action.congratulationsNoActions' | translate }} <br />
                      {{ 'action.youDeserveCoffee' | translate }}
                    </h2>
                  </div>
                  <div class="box d-flex align-items-center justify-content-center py-4">
                    <img src="./assets/img/undraw_coffee_break_j3of.svg" width="35%" [alt]="'action.noActions' | translate" class="img-fluid" />
                  </div>
                </div>
              }
              @if (actionsListAssignedToMyTeam?.items?.length !== 0) {
                <div class="listActions p-col-12 mt-3">
                  <!-- Vue liste -->
                  @if (valueJustifyOption?.state === 'list') {
                    <section class="overflowAuto">
                      @for (
                        action of actionsListAssignedToMyTeam?.items | filterByPropertyNotNull: 'action' | advancedSearch: dataSearch : excludedKeys;
                        track action
                      ) {
                        <app-action-card [action]="action" [mode]="actionTabsActive" (emitAnswerToAction)="answerToAction($event)"></app-action-card>
                      }
                    </section>
                  }
                  @if (valueJustifyOption?.state === 'list') {
                    <div class="d-flex justify-content-center align-items-center">
                      <p-paginator
                        #pgAssignedToMyTeam
                        [first]="firstAssignedToMyTeam"
                        [rows]="actionsListAssignedToMyTeam?.pageSize"
                        [rowsPerPageOptions]="[100, 200, 500, 1000, 5000]"
                        [totalRecords]="actionsListAssignedToMyTeam?.totalCount"
                        (onPageChange)="onPageChange($event, 'assignedToMyTeam')"
                        [templateRight]="divRightMyTeam"
                        [showJumpToPageDropdown]="false">
                        <ng-template #divRightMyTeam>
                          <span class="darkBlueColor">{{ 'action.itemsPerPage' | translate }}</span>
                        </ng-template>
                      </p-paginator>
                    </div>
                  }
                  <!-- Vue tableau -->
                  @if (valueJustifyOption.state === 'table') {
                    <div class="d-flex align-items-center justify-content-between">
                      <div>
                        <p-dropdown
                          [(ngModel)]="sizeChoice"
                          [options]="sizeOfPages"
                          (onChange)="changePageSize($event, 'assignedToMyTeam')"
                          inputStyleClass="w-100"
                          styleClass="dropdown-inforius">
                        </p-dropdown>
                      </div>
                      <div>
                        <small class="me-3">{{
                          'pageOn'
                            | translate: { pageNumber: actionsListAssignedToMyTeam?.pageNumber, pageSize: actionsListAssignedToMyTeam?.totalPages }
                        }}</small>
                        <div>
                          @if (+actionsListAssignedToMyTeam?.pageNumber !== 1) {
                            <button
                              class="super-compos-secondary-btn me-1"
                              (click)="paginate('assignedToMyTeam', +actionsListAssignedToMyTeam?.pageNumber - 1)"
                              style="border-radius: 6px 0px 0px 6px">
                              <img src="./assets/img/arrow_l.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                          @if (
                            actionsListAssignedToMyTeam?.pageNumber !== actionsListAssignedToMyTeam?.totalPages &&
                            actionsListAssignedToMyTeam?.totalPages > 1
                          ) {
                            <button
                              [disabled]="actionsListAssignedToMyTeam?.pageNumber === actionsListAssignedToMyTeam?.totalPages"
                              class="super-compos-secondary-btn"
                              (click)="paginate('assignedToMyTeam', +actionsListAssignedToMyTeam?.pageNumber + 1)"
                              style="border-radius: 0px 6px 6px 0px">
                              <img src="./assets/img/arrow_r.svg" class="edeb-arrow-icon" alt="" />
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (valueJustifyOption.state === 'table') {
                    <div>
                      @if (superTableLoaded) {
                        <i-table
                          id="actionsSuperTableAssignedToMyTeams1"
                          class="super-table box"
                          [columns]="columns"
                          [items]="actionsListAssignedToMyTeam?.items"
                          [multiselect]="false"
                          [paginator]="true"
                          [rows]="actionsListAssignedToMyTeam?.pageSize"
                          [totalRecords]="actionsListAssignedToMyTeam?.totalCount"
                          [firstPage]="0"></i-table>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </section>
} @else {
  <div class="loader_div">
    <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
  </div>
}
